<div class="app-es-ocr-quick-fix-shipment-type-details">
  <div class="app-es-ocr-quick-fix-shipment-type-details__header">
    <div class="app-es-ocr-quick-fix-shipment-type-details__header__left">
      <p class="app-es-ocr-quick-fix-shipment-type-details__header__title">
        {{ "LABELS.SHIPMENT_DETAILS" | translate | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'LABELS.EDIT_SHIPMENT_DETAILS_DESCRIPTION' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <es-shipment-details-form-desktop
    [entrySummary]="entrySummary"
    [company]="company"
    [formGroup]="formGroup"
    [isSidebar]="true"
  ></es-shipment-details-form-desktop>
</div>
